// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2BvBn","topBottomGutter":"Layout_topBottomGutter__6T_Y_"};